import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {}

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    return {
      title: 't(New Folder)',
      method: 'POST',
      action: '/api/admin/truevail/agency/folders',
      onCancel: this._handleCancel,
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Title)', 
              name: 'title', 
              type: 'textfield', 
              required: false 
            },
            { 
              label: 't(Thumbnail)', 
              name: 'thumbnail_id', 
              type: 'attachmentfield', 
              multiple: false 
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(post) {
    this.context.modal.close()
  }

}

export default New
